import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }
const SustentoTributarioComprobanteTipo = {
    async Get() { return await methods.Get("SustentoTributarioComprobanteTipo/Get") },
    async Post(data) { return await methods.Post("SustentoTributarioComprobanteTipo/Post", data) },
    async Put(qs, data) { return await methods.Put("SustentoTributarioComprobanteTipo/Put" + useParamsJson(qs), data) },
    async Delete(qs) { return await methods.Delete("SustentoTributarioComprobanteTipo/Delete" + useParamsJson(qs)) },
   
  
};

export default SustentoTributarioComprobanteTipo;